import { contactWorksBodyTemplates } from '../templates/ContactWorksTemplates'
import { FilterMatchMode } from 'primereact/api'


/**
 * Shared column definitions for Contact Works tables
 * Used by both ContactWorksStaticTable and ContactWorksNestedTable
 */

/**
 * Column definitions for Contact Works tables
 * Compatible with both StaticGrid and LazyGrid
 */
export const contactWorksColumnDefinitions = [
{
    columnType: 'worktype',
    title: 'Type',
    mapsToField: 'domain',
    filter: true,
    filterMatchMode: FilterMatchMode.EQUALS,
    sortable: true,
    style: { width: '80px' },
    template: contactWorksBodyTemplates.domain
},
    {
        columnType: 'text',
        title: 'Title',
        mapsToField: 'workTitle',
        filter: true,
        sortable: true,
        style: { width: '250px' },
        template: contactWorksBodyTemplates.workTitle
    },
    {
        columnType: 'text',
        title: 'Episode title',
        mapsToField: 'episodeTitle',
        filter: true,
        sortable: true,
        style: { width: '200px' },
        template: contactWorksBodyTemplates.episodeTitle
    },
    {
        columnType: 'workcontributiontype',
        title: 'Contribution',
        mapsToField: 'contributionType',
        filter: true,
        filterMatchMode: FilterMatchMode.EQUALS,
        sortable: true,
        style: { width: '120px' },
        template: contactWorksBodyTemplates.contributionType
    },
    {
        columnType: 'text',
        title: 'ISBN',
        mapsToField: 'isbn',
        filter: false,
        sortable: false,
        style: { width: '100px' },
        template: contactWorksBodyTemplates.isbn
    },
    {
        columnType: 'text',
        title: 'ISSN',
        mapsToField: 'issn',
        filter: false,
        sortable: false,
        style: { width: '100px' },
        template: contactWorksBodyTemplates.issn
    },
    {
        columnType: 'avtype',
        title: 'AV type',
        mapsToField: 'avType',
        filter: true,
        filterMatchMode: FilterMatchMode.EQUALS,
        sortable: true,
        style: { width: '90px' },
        template: contactWorksBodyTemplates.avType
    },
    {
        columnType: 'text',
        title: 'Added by',
        mapsToField: 'addedBy',
        filter: false,
        sortable: false,
        style: { width: '150px' },
        template: contactWorksBodyTemplates.addedBy
    }
]
